export default __webpack_public_path__ + "locales/lo-LA/ConvertDialog.json?hash=985b39786ac77180a1234eef65388a43";